import Validator from "validatorjs";
import { NAMEREGEX } from "@constants/regex";

const nameRegex = `regex:${NAMEREGEX}`;

export const validate = props => {
  const rules = {
    firstname: [nameRegex],
    lastname: [nameRegex],
    street: ["regex:/^[Aa-zA-Z\\d\\s-.,#'/]*$"],
    street2: ["regex:/^[Aa-zA-Z\\d\\s-.,#'/]*$"],
    city: ["regex:/^[a-zA-Z]+(?:(?:\\s+\\|-)[a-zA-Z]+)*$"],
    zip: ["regex:/^\\d{5}(?:[-\\s]\\d{4})?$"],
    phone: [
      "regex:/^1?\\W*([2-9][0-8][0-9])\\W*([2-9][0-9]{2})\\W*([0-9]{4})(\\se?x?t?(\\d*))?$"
    ]
  };

  const errorMessages = {
    "regex.firstname": "First name is invalid",
    "regex.lastname": "Last name is invalid",
    "regex.street": "Street is invalid.",
    "regex.street2": "Apt is invalid.",
    "regex.city": "City is invalid.",
    "regex.zip": "Zip code is invalid.",
    "regex.phone": "Phone is invalid."
  };

  const trimmedProps = Object.keys(props).reduce((acc, key) => {
    acc[key] = typeof props[key] === "string" ? props[key].trim() : props[key];
    return acc;
  }, {});

  const validator = new Validator(trimmedProps, rules, errorMessages);

  validator.passes();
  return validator.errors.all();
};

export const normalizePhone = value => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, "");

  if (onlyNums.length <= 3) {
    return onlyNums;
  }

  if (onlyNums.length <= 7) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
  }

  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(
    6,
    10
  )}`;
};

export const normalizePhoneForDisplay = value => {
  let newValue = value;
  if (value.length === 11 && value.startsWith("1")) {
    newValue = value.slice(1, value.length);
  }
  return normalizePhone(newValue);
};

export const stripPhoneFormatting = phone => phone.split("-").join("");
